module.exports = {
      id: "marginnote-banner-right-usage",
      viewBox: "0 0 648 445",
      url: __webpack_public_path__ + "images/js_src_vue/page_marginnote_landing/sprite.20f12c2e.svg#marginnote-banner-right-usage",
      toString: function () {
        return this.url;
      }
    }